<template>
	<div id="legalFQA" data-role="page">
		<!-- content -->
		<div class="legalFQA-content" data-position="fixed">
			<!-- swiperTop 分類 -->
			<div id="Top" class="swiper-container swiperTop">
				<swiper :options="swiperTop" ref="Top">
                    <swiper-slide class="swiper-slide selected" news_type='all'>全部</swiper-slide>
					<swiper-slide class="swiper-slide" v-for="(tag,tag_ind) in news_tag" :key="tag_ind" :news_type="tag.type_id">{{tag.type_name}}</swiper-slide>
				</swiper>
			</div>
            <div id="Pages" class="swiper-container swiperPages">
                <swiper :options="swiperPages" class="swiper-wrapper" ref="Pages">
                    <swiper-slide class="swiper-slide">
						<div class="detailWrap">
							<div class="articleList">
								<ul>
									<li v-for="(news,news_ind) in news_list" :key="news_ind">
                                        <!-- <a :href="'#/newsDetail/'+news.news_id"> -->
                                        <router-link :to="{name:'newsDetail', params: { id : news.news_id}}">
                                            <div class="topicImg">
                                                <div class="mainImg" v-lazy:background-image="news.title_img" v-if="news.title_img != ''"></div> 
                                                <div class="mainImg" v-if="news.title_img == ''"></div>
                                            </div>
                                            <div class="txt-info">
                                                <span class="article_desc">{{news.title}}</span>
                                                <span class="article_date">{{news.news_date.split(" ")[0]}}</span>
                                                <div class="metaDiv">
                                                    <span class="cgy-tag">{{chn_tag(news.news_type)}}</span>
                                                    <span v-if="Authority" class="bookmark-tag"><i v-bind:class="[news.is_keep ? 'icon-bookmark-full active' : 'icon-bookmark'  ,'bookmarkIcon']" v-on:click.prevent="SetFavorites(news.news_id,news.is_keep)"></i></span>
                                                </div>
                                            </div>
                                        </router-link>                                        
                                        <!-- </a> -->
									</li>
								</ul>
							</div>
						</div>                        
                    </swiper-slide>   
					<swiper-slide class="swiper-slide" v-for="(tag,tag_ind) in news_tag" :key="tag_ind">
						<div class="detailWrap">
							<div class="articleList">
								<ul>
									<li v-for="(news,news_ind) in news_list" :key="news_ind" v-if="tag.type_id === news.news_type">
                                        <router-link :to="{name:'newsDetail', params: { id : news.news_id}}">
                                            <div class="topicImg">
                                                <div class="mainImg" v-lazy:background-image="news.title_img" v-if="news.title_img != ''"></div>
                                                <div class="mainImg" v-if="news.title_img == ''"></div>
                                            </div>
                                            <div class="txt-info">
                                                <span class="article_desc">{{news.title}}</span>
                                                <span class="article_date">{{news.news_date.split(" ")[0]}}</span>
                                                <div class="metaDiv">
                                                    <span class="cgy-tag">{{chn_tag(news.news_type)}}</span>
                                                    <span v-if="Authority" class="bookmark-tag"><i v-bind:class="[news.is_keep ? 'icon-bookmark-full active' : 'icon-bookmark'  ,'bookmarkIcon']" v-on:click.prevent="SetFavorites(news.news_id,news.is_keep)"></i></span>
                                                </div>
                                            </div>
                                        </router-link>
									</li>
								</ul>
								<!-- <p class="moreBtn">載入更多</p> -->
							</div>
						</div>                        
                    </swiper-slide>            
				</swiper>
            </div>
		</div>

        <favoritesToast
                :show="toastControl.show"
                :full="toastControl.full"
                :content="toastControl.content"
                :showTime="toastControl.showTime"
                @close="toastControl.show = false"
            ></favoritesToast>
    </div>        
</template>

<script lang="js">
import favoritesToast from '@/components/common/toast/favoritesToast';
export default {
    components: { favoritesToast },
    data () {
        return {
            swiperTop: {
                slidesPerView: 'auto',
                aginationClickable: true,//此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
                spaceBetween: 10,//slide之间的距离（单位px）。
                freeMode: true,//默认为false，普通模式：slide滑动时只滑动一格，并自动贴合wrapper，设置为true则变为free模式，slide会根据惯性滑动且不会贴合。
                loop: false,//是否可循环
            },
            swiperPages:{
                direction: 'horizontal',//Slides的滑动方向，可设置水平(horizontal)或垂直(vertical)。
                loop: false,
                preloadImages: false,
                lazy: true,
                autoHeight: true,//自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。
                // on:{
                //     slideChangeTransitionStart(){
                //         $(".swiperTop .swiper-slide").removeClass("selected");
                //         $(".swiperTop .swiper-slide").eq(this.activeIndex).addClass("selected");
                //         let page=($($(".swiperTop .swiper-slide").eq(this.activeIndex)).attr('news_type'))
                //         window.localStorage.setItem('GotoNewsPage',page)
                //     },
                //     slideChangeTransitionEnd(){
                //         $(".swiperTop .swiper-slide").removeClass("selected");
                //         $(".swiperTop .swiper-slide").eq(this.activeIndex).addClass("selected");
                //         let page=($($(".swiperTop .swiper-slide").eq(this.activeIndex)).attr('news_type'))
                //         window.localStorage.setItem('GotoNewsPage',page)
                //     }
                // }
            },
            news_tag:[],
            news_list:[],
            url : Imgurl,
            Authority: false,
            toastControl:{
                show: false,
                full: false,
                content: '',
                showTime: 1000
            }
        }
    },
    mounted(){
        window.localStorage.setItem('GotoNewsPage','all')
        let vobj = this;
        vobj.GetNewsType();
        this.CheckAuthority();

        vobj.$refs.Pages.swiper.on('slideChangeTransitionStart', function(){
            $(".swiperTop .swiper-slide").removeClass("selected");
            $(".swiperTop .swiper-slide").eq(this.activeIndex).addClass("selected");
            vobj.tagTranslate(this.activeIndex)
            let page=($($(".swiperTop .swiper-slide").eq(this.activeIndex)).attr('news_type'))
            window.localStorage.setItem('GotoNewsPage',page)


        }).on('slideChangeTransitionEnd', function(){
            $(".swiperTop .swiper-slide").removeClass("selected");
            $(".swiperTop .swiper-slide").eq(this.activeIndex).addClass("selected");
            vobj.tagTranslate(this.activeIndex)
            let page=($($(".swiperTop .swiper-slide").eq(this.activeIndex)).attr('news_type'))
            window.localStorage.setItem('GotoNewsPage',page)
        })
        //swiper設定
        // this.$nextTick(() => {
        //     const Top = this.$refs.Top.swiper
        //     const Pages = this.$refs.Pages.swiper
        //     Pages.controller.control = Top
        // })
    },
    methods:{
        //回傳標籤名稱
        chn_tag(news_type){
            return this.$root.GetNewsTypeChn(news_type);
        },
        //取的tag
        GetNewsType(){
            let vobj = this;
            vobj.$root.GetNewsType(function(callback){
                vobj.news_tag = callback.map((val)=>{
                    return val;
                });
                //取得新訊列表
                vobj.GetNewsList();
            });          
        },
        //取得新訊列表
        GetNewsList(){
            let vobj=this;
            this.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetCommitteeNewsList`,{
                headers:{Authorization: Token}
            }).then((response) => {
                if(response.status == 200){
                    vobj.news_list =  response.data.data
                    console.log(vobj.news_list);
                    setTimeout(()=>{
                        if(location.href.indexOf("?") != -1){
                            let news_type = parseInt(location.href.split("?news_type=")[1]);
                            const Top = this.$refs.Top.swiper;
                            console.log(Top)
                            Top.slides.each(function(index, val){
                                let now_news_type =$(val).attr('news_type');
                                if(now_news_type == news_type){
                                    vobj.SlidesToPage(index);
                                }
                            })
                        }
                    },500)
                    this.CleanBlankPage();
                }
            })
        },
        //清除空白頁面
        CleanBlankPage(){
            let tags = this.news_tag.map((val)=>{
                return {type_id:val.type_id,type_name:val.type_name,length:0}
            });
            for(let i=0;i<this.news_list.length;i++){
                for(let j = 0;j<tags.length;j++){
                    if(this.news_list[i].news_type==tags[j].type_id){
                        tags[j].length+=1;
                    }
                }
            }
            this.news_tag = tags.filter((val)=>{
                return val.length >0;
            })
        },      
        //切換頁面
        SlidesToPage(page){
            const Top = this.$refs.Top.swiper;
            const Pages = this.$refs.Pages.swiper
            Pages.slideTo(page, 500);
            $(".swiperTop .swiper-slide").removeClass("selected");
            $(".swiperTop .swiper-slide").eq(page).addClass("selected");
        },
        //加入收藏
        SetFavorites(id,status){
            let vobj = this;
            if(vobj.toastControl.show) return false
            let status_val = 0;
            status ? (status_val=0 ) : (status_val=1);
            vobj.$root.SetFavorites(0,id,status_val,function(res){
                if(res){
                    vobj.news_list.map((val,ind)=>{
                        if(val.news_id == id){
                            vobj.news_list[ind]['is_keep'] = status ? (false):(true);
                        }
                    })

                    status ? vobj.UnfavoritesToast() : vobj.FavoritesToast()
                }
            });
        },
        //檢查權限
        CheckAuthority(){
            if(localStorage.getItem("token")=='' || localStorage.getItem("token") == null){
                this.Authority= false
            }else{
                this.Authority= true
            }
        },
        FavoritesToast(){
            this.toastControl.content = '已加入收藏'
            this.toastControl.full = true
            this.toastControl.show = true
        },
        UnfavoritesToast(){
            this.toastControl.content = '已取消收藏'
            this.toastControl.full = false
            this.toastControl.show = true
        },
        tagTranslate(index){
            var topWidth = 0
            var offetLeft = 0 //點擊tag 與左邊距離
            const Top = this.$refs.Top.swiper;
            Top.slideTo(index)
            $('#Top').find('.swiper-slide').each(function(idx, el){
                topWidth += $(this).outerWidth(true)
                if(idx < index){
                    offetLeft += $(this).outerWidth(true)
                }
            })
            topWidth -= 10  //最後一個沒有margin

            var translateLimit = topWidth - $(window).width()  //最長可translate3d的距離
            // 如果靠左距離 大於可滾動距離 則以可滾對最大距離為主
            offetLeft = offetLeft > translateLimit ? 0 - translateLimit : 0 - offetLeft

            $('.swiperTop .swiper-wrapper').css({
                'transform': 'translate3d('+ offetLeft +'px, 0px, 0px)'  ,
                'transition-duration': '300ms'
            })
        }
    },
    watch: {
        news_list(){
            var setCurrentSlide = (ele, index)=>{
                $(".swiperTop .swiper-slide").removeClass("selected");
                ele.addClass("selected");
                this.tagTranslate(index)
            }  
            const Top = this.$refs.Top.swiper;
            const Pages = this.$refs.Pages.swiper
            Top.slides.each(function(index, val){
                var ele = $(this);
                ele.on("click", function() {
                    setCurrentSlide(ele, index);
                    Pages.slideTo(index, 500);
                });
            })
            $('#Pages').find(".swiper-slide").map(function(){
                let PageHeight = $(window).height()-$('#Top').height();
                $(this).css('height',PageHeight+'px');
            });
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/components/news.vue